<template>
  <div>
    <h1 class="mt-5">{{ $t('Anonymní obsah') }}</h1>
  </div>
</template>

<script>
//import { state } from '@/lib/store.js'

export default {
  components: { },

  computed: {
      /*state( ) {
          return state
      }*/
  },

  methods: { }
}
</script>